<style scoped>
</style>

<template>
	<div id="page_not_found" class="pa-8">
		Sorry but this page could not be found...
	</div>
</template>

<script>
export default {
	name: "PageNotFound",
	data() {
		return {
			/* nothing */
		}
	},
}
</script>